'use strict';

angular.module('theme').service('WeekMenuService', function ($q, $http) {

	this.get = function (articleId) {
		if (!articleId) {
			return $q.reject('articleId cannot be null');
		}

		return $http({
			url: '/wp-json/mk/menus/' + articleId,
			method: 'GET',
			cache: true
		}).then(function (response) {

			if (!response.data) {
				return $q.reject('no menu with ' + articleId + ' found');
			}

			response.data.deliveryDate = moment(response.data.menu_delivery, 'YYYYMMDD').toDate();

			return response.data;
		});
	};

	this.getPreview = function (previewWeek) {

		if (!previewWeek) {
			var now = moment();
			if (now.day() === 1 && now.hour() < 13) {
				now.add(1, 'weeks');
			} else {
				now.add(2, 'weeks');
			}
			previewWeek = Number.parseInt(now.format('W'), 10);
		}

		// Winter pause
		if (previewWeek === 52) {
			previewWeek = 1;
		}

		return $http({
			url: '/wp-json/mk/menus/preview/' + previewWeek,
			method: 'GET',
			cache: true
		}).then(function (response) {
			_.forEach(response.data, function (menu) {
				menu.deliveryDate = moment(menu.menu_delivery, 'YYYYMMDD').toDate();
			});
			return response.data;
		});
	};

	this.getPreviews = function (fromDate) {
		return $http({
			url: '/wp-json/mk/menus/previews/' + fromDate,
			method: 'GET',
			cache: true
		}).then(function (response) {
			_.forEach(response.data, function (menu) {
				menu.deliveryDate = moment(menu.menu_delivery, 'YYYYMMDD').toDate();
			});
			return response.data;
		});
	};

	this.getWeekMenus = function (week) {
		return $http({
			url: '/wp-json/mk/menus/preview/' + week,
			method: 'GET',
			cache: true
		}).then(function (response) {
			_.forEach(response.data, function (menu) {
				menu.deliveryDate = moment(menu.menu_delivery, 'YYYYMMDD').toDate();
			});
			return response.data;
		});
	};

});
